module.exports = __webpack_public_path__ + "img/sandpiper.2b5107cd.jpg";